import { connect, Dispatch } from 'react-redux';
import { IApplicationState } from '@nkr/store/index';
import { ContainerWrapper } from './styles';
import { UserGroup } from '@nkr/enums/user-group';
import { useAppHookContext } from '@nkr/utils/rest-api';
import CenterNav from './center-nav';
import CenterProfileEditContainer from './edit';
import Contacts from '@nkr/views/contacts/list';
import ContactAddEdit from '@nkr/views/contacts/add-edit';
import ClsOverrides from '@nkr/views/admin/center/profile';
import WaitlistAllocation from '@nkr/views/waitlist-allocation';
import DashCenterWorkflowStatus from './workflow-config'
import UserList from '../users/user-list';
import CenterAddresses from './addresses/list';
import FollowUpLabOptionsList from './follow-up-lab-options/list';
import ReferralConfig from '@nkr/views/center-profile/referral-config';
import BulkCheekSwabRequest from './bulk-cheek-swab-request';

interface IProps {
    centerId: number,
    section: string,
    subSection: string,
    isAdmin: boolean,
    isAdminLogin: boolean,
    contactId?: number
}

interface IStateProps {
    centerAdmin: boolean
}

interface IDispatchProps {
}

type TProps = IProps & IStateProps & IDispatchProps;

const CenterProfileContainer = (props: TProps) => {
    const {app} = useAppHookContext();

    const centerAlias = app.center != null ? app.center.alias : '';

    return (
        <>
            <ContainerWrapper className="container-fluid">
                {props.isAdmin && (
                    <div style={{ fontSize: 28, marginBottom: 20 }}><strong>{centerAlias}</strong> Profile</div>
                )}

                <CenterNav
                    activeKey={props.section}
                    isAdmin={props.isAdmin}
                    centerAdmin={props.centerAdmin}
                    onTabSelect={() => null}
                    centerId={props.centerId} />

                {props.section == 'EDIT' && (
                    <div className='center-profile-section'>
                        <CenterProfileEditContainer
                            activeKey={props.subSection}
                            centerId={props.centerId}
                            isAdmin={props.isAdmin}
                            isAdminUser={props.isAdminLogin}
                        />
                    </div>
                )}

                {props.section == 'CONTACTS' && (
                    <div className='center-profile-section'>
                        <Contacts
                            isCenter={true}
                            centerId={props.centerId}
                        />
                    </div>
                )}

                {props.section == 'EDIT-CONTACT' && (
                    <div className='center-profile-section'>
                        <ContactAddEdit
                            contactId={props.contactId}
                            centerId={props.centerId}
                            isCenter={true}
                        />
                    </div>
                )}

                {props.section == 'ADD-CONTACT' && (
                    <div className='center-profile-section'>
                        <ContactAddEdit
                            contactId={0}
                            centerId={props.centerId}
                            isCenter={true}
                        />
                    </div>
                )}

                {props.section == 'D2D-CLS' && (
                    <div className='center-profile-section'>
                        <ClsOverrides centerId={props.centerId} />
                    </div>
                )}

                {props.section == 'REFERRAL-CONFIG' && (
                    <div className='center-profile-section'>
                        <ReferralConfig
                            centerId={props.centerId}
                            isAdmin={props.isAdmin}
                            isAdminUser={props.isAdminLogin}
                        />
                    </div>
                )}

                {props.section == 'WAITLIST-CONFIG' && (
                    <div className='center-profile-section'>
                        <WaitlistAllocation centerId={props.centerId} />
                    </div>
                )}

                {props.section == 'FU-LAB-OPTION' && (
                    <div className='center-profile-section'>
                        <FollowUpLabOptionsList
                            centerId={props.centerId}
                            isCenter={props.isAdmin == false}
                            clearFile={null}
                        />
                    </div>
                )}

                {props.section == 'WORKFLOW-CONFIG' && (
                    <div className='center-profile-section'>
                        <DashCenterWorkflowStatus
                            centerId={props.centerId}
                            isCenter={true}
                        />
                    </div>
                )}

                {props.section == 'USERS' && (
                    <div className='center-profile-section'>
                        <UserList
                            centerId={props.centerId}
                            isAdmin={props.isAdmin}
                        />
                    </div>
                )}

                {props.section == 'ADDRESSES' && (
                    <div className='center-profile-section'>
                        <CenterAddresses
                            centerId={props.centerId}
                            isCenter={props.isAdmin == false}
                        />
                    </div>
                )}

                {props.section == 'CHEEK-SWAB-REQUEST' && (
                    <div className='center-profile-section'>
                        <BulkCheekSwabRequest centerId={props.centerId} />
                    </div>
                )}
            </ContainerWrapper>
        </>
    );
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        centerAdmin: [UserGroup.CenterAdmin, UserGroup.Admin].includes(appState.app.user.groupId)
    };
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        // getBaseCenter: (centerId) => {
        //     return dispatch(AppActionCreators.getBaseCenter(centerId));
        // },
    }
}

export default connect<IStateProps, {}, IProps>(
    mapStateToProps,
    mapDispatchToProps)(CenterProfileContainer);
